import ComparisonAutomation from "container/JobRequests/JobRequestDetails/Quotations/ComparisonAutomation/ComparisonAutomation";

export default function Automation() {
  return <>
    <ComparisonAutomation></ComparisonAutomation>
  </>
}
